// import logo from './logo.svg';
import { useEffect, useState } from 'react';
import './App.css';
import Accordion from './components/Accordion';

const getDataAttributes = () => {
  const rootDiv = document.getElementById("root");

  if (!rootDiv) {
    console.error("Root div not found!");
    return null;
  }

  const dataAttributes = {
    courses: rootDiv.getAttribute("data-courses"),
    level: rootDiv.getAttribute("data-level"),
    rank: rootDiv.getAttribute("data-rank"),
    primary: rootDiv.getAttribute("data-primary"),
    secondary: rootDiv.getAttribute("data-secondary"),
    type: rootDiv.getAttribute("data-type"),
    api: rootDiv.getAttribute("data-api"),
    lang: rootDiv.getAttribute("data-lang"),
    currency: rootDiv.getAttribute("data-currency"),
  };

  return dataAttributes;
};

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const data = getDataAttributes();
    const root = document.documentElement;
    root.style.setProperty("--primary-color", data.primary);
    root.style.setProperty("--secondary-color", data.secondary);
    setData(data)
  }, [])

  return (
    <div className="App">
      <Accordion data={data} />
    </div>
  );
}

export default App;
